import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import {
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import LimitExpandedComponent from ".//row-expand-limit.component";
import moment from "moment";
import { agentLimitList } from "./../../../actions/agent-limit-action";
import Confirmation from "../../common/modals/confirmation.component.js";
import ConfigurationService from "../../../services/configuration-service";
import { useData } from "../../../contexts/dataContext";

const AgentLimitListView = () => {
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  // const [limitList, setLimitList] = useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const selectRows = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);
  const limitList = useSelector(
    (state) => state.configurationReducer.agentLimitList
  );
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [row, setRow] = useState({});
  const { setGlobalData } = useData();

  const columns = [
    {
      name: "Limit Group Name",
      selector: (row) => row.limit_group_name,
      sortable: true,
    },
    {
      name: "Maximum In Amount",
      selector: (row) => `₹${row.max_amount_cashin_limit}`,
      sortable: true,
    },
    {
      name: "Maximum Out Amount",
      selector: (row) => `₹${row.max_amount_cashout_limit}`,
      sortable: true,
    },
    {
      name: "Status",
      sortable: true,
      button: true,
      selector: (row) => row.status,
      style: (row) => ({ justifyContent: "flex-start" }),
      cell: (row) => (
        <>
          <div
            className={`badge badge-pill ${getStatusClass(
              row.status
            )} font-size-12`}
            style={{
              backgroundColor:
                row.limit_group_id && !!expanded[row.limit_group_id]
                  ? "white"
                  : "",
            }}
          >
            {row.status}
          </div>
        </>
      ),
      // cell: row =>
      //  <>
      //     <span className="mgh">
      //       <img style={{width: '15px'}} src="https://cdn-icons-png.flaticon.com/512/1011/1011500.png" />
      //     </span>
      //     </>
    },
    {
      name: "Created At",
      selector: (row) =>
        row.created_on
          ? moment(row.created_on, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")
          : "-",
      sortable: true,
    },
    {
      name: "Updated At",
      selector: (row) =>
        row.updated_on
          ? moment(row.updated_on, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")
          : "-",
      sortable: true,
    },
    {
      name: "Actions",
      button: true,
      cell: (row) => (
        <>
          <a
            className={`fview tooltip`}
            style={{ cursor: "pointer" }}
            onClick={() => viewLimitList(row.limit_group_id)}
          >
            <i
              className={`fa ${
                row.status === "Rejected" ? "fa-eye disable" : "fa-eye"
              }`}
              style={{
                color:
                  row.limit_group_id && !!expanded[row.limit_group_id]
                    ? "white"
                    : "black",
              }}
            />
            <span className="tooltiptext">View</span>
          </a>
          <a
            className="flock tooltip"
            onClick={() => changeStatus(row)}
            href="#"
          >
            <i
              className={`fa ${
                row.status === "Initiated" || row.status === "Rejected"
                  ? "fa-lock disable"
                  : row.status === "Suspended"
                  ? "fa-unlock"
                  : "fa-lock"
              }`}
              style={{
                color:
                  row.limit_group_id && !!expanded[row.limit_group_id]
                    ? "white"
                    : "black",
              }}
            />
            <span className="tooltiptext">
              {" "}
              <>
                {row.status !== "Active"
                  ? "UnLock"
                  : "Lock" // Or whatever you want to show if the status is 'Active'
                }
              </>
            </span>
          </a>
          <a
            className={`fedit tooltip ${
              row.status === "Rejected" || row.status === "Suspended"
                ? "disable"
                : ""
            }`}
            onClick={() => openSelectedAgentLimits(row)}
            href="#"
          >
            <i
              className={`fa ${
                row.status === "Rejected" || row.status === "Suspended"
                  ? "fa-edit disable"
                  : "fa-edit"
              }`}
              style={{
                color:
                  row.limit_group_id && !!expanded[row.limit_group_id]
                    ? "white"
                    : "black",
              }}
            />
            <span className="tooltiptext">Edit</span>
          </a>
          <a
            className="ftrash tooltip"
            onClick={() => deleteAgentLimit(row)}
            href="#"
          >
            <i
              className="fa fa-trash"
              style={{
                color:
                  row.limit_group_id && !!expanded[row.limit_group_id]
                    ? "white"
                    : "black",
              }}
            />
            <span className="tooltiptext">Delete</span>
          </a>
          <a
            className="fell tooltip"
            href="#"
            style={{ paddingRight: "25px", cursor: "pointer" }}
          >
            <i
              className="fa fa-ellipsis-v"
              style={{
                color:
                  row.limit_group_id && !!expanded[row.limit_group_id]
                    ? "white"
                    : "black",
              }}
              aria-hidden="true"
            />
            <span className="tooltiptext">More</span>
          </a>
        </>
      ),
    },
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "badge-soft-success";
      case "Initiated":
        return "badge-soft-pending";
      case "Rejected":
        return "badge-soft-warning";
      case "Suspended":
        return "badge-soft-received";
      case "Deleted":
        return "badge-soft-danger";
      default:
        return "";
    }
  };

  const changeStatus = (row) => {
    setModalShow(true);
    setRow({
      limit_group_id: row.limit_group_id,
      status: row.status,
      modalId: "statusChangeAgentLimit",
    });
  };

  const deleteAgentLimit = (row) => {
    setModalShow(true);
    setRow({
      limit_group_id: row.limit_group_id,
      status: row.status,
      modalId: "deleteAgentLimit",
    });
  };

  const deleteConfirmation = () => {
    setLoading(true);
    ConfigurationService.deleteAgentLimit(row.limit_group_id)
      .then((response) => {
        toast.success(MESSAGES.AGENT_LIMIT_DELETED);
        getAgentLimitList();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
        setModalShow(false);
      });
  };

  const updateStatus = () => {
    console.log(row.status);
    if (row.modalId == "statusChangeAgentLimit") {
      const suspended = [];
      const resume = [];
      if (row.status.toLowerCase() == "active") {
        suspended.push(row.limit_group_id);
        suspendAgentLimit(suspended);
      } else {
        resume.push(row.limit_group_id);
        resumeAgentLimit(resume);
      }
    } else if (row.modalId == "statusChangeLimitSuspend") {
      const suspended = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].status_id.toLowerCase() == "a") {
          suspended.push(selectedRows[i].limit_group_id);
        }
      }
      suspendAgentLimit(suspended);
    } else if (row.modalId == "statusChangeLimitResume") {
      const resume = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].status_id.toLowerCase() == "s") {
          resume.push(selectedRows[i].limit_group_id);
        }
      }
      resumeAgentLimit(resume);
    } else {
      deleteConfirmation();
    }
  };

  const resumeAgentLimit = (resume) => {
    setLoading(true);
    ConfigurationService.resumeAgentLimit(resume)
      .then((response) => {
        toast.success(MESSAGES.AGENT_LIMIT_RESUME);
        getAgentLimitList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([]);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  const suspendAgentLimit = (suspended) => {
    setLoading(true);
    ConfigurationService.suspendAgentLimit(suspended)
      .then((response) => {
        toast.success(MESSAGES.AGENT_LIMIT_SUSPENDED);
        getAgentLimitList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([]);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  const formatCreatedAt = (date) => {
    const parsedDate = moment(date, "DD-MM-YYYY HH:mm:ss");
    // Change the format according to your needs
    return moment(parsedDate).format("DD-MM-YY HH:mm:ss");
  };

  const getAgentLimitList = (e) => {
    setLoading(true);
    dispatch(agentLimitList())
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getAgentLimitList();
    document.body.style.backgroundImage = "";

    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  const navigate = useNavigate();

  const openSelectedAgentLimits = (data) => {
    setGlobalData(data);
    navigate("/add-agent-limit");
  };

  const addNewAgentLimits = (e) => {
    setGlobalData(null);
    navigate("/add-agent-limit");
  };
  const viewLimitList = (id) => {
    navigate(`/view-agent-limits/${id}`);
  };

  const handleRowExpand = (row, data) => {
    const newExpanded = { ...expanded };
    newExpanded[data.limit_group_id] = !expanded[data.limit_group_id];
    setExpanded(newExpanded);
  };
  const conditionalRowStyles = [
    {
      when: (data) => data.limit_group_id && !!expanded[data.limit_group_id],
      style: {
        backgroundColor: "#3280dd !important",
        color: "white",
      },
    },
  ];
  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
  };

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  };
  const filteredData = limitList.filter((row) =>
    Object.values(row).some((value) =>
      new RegExp(escapeRegExp(searchTerm), "i").test(value)
    )
  );

  const resetSearch = () => {
    setSearchTerm("");
  };

  const customExpandableIcon = {
    collapsed: <span className="collapsed-icon"></span>,
    expanded: <span className="expand-icon"></span>,
  };

  const suspendMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Suspend",
      modalId: "statusChangeLimitSuspend",
    });
  };

  const resumeMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Resume",
      modalId: "statusChangeLimitResume",
    });
  };

  useEffect(() => {
    if (filteredData?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("even-transaction-table");
        } else {
          childElement[i].classList.add("odd-transaction-table");
        }
      }
    }
  }, [filteredData]);

  return (
    <div>
      <LoaderOverlay loading={loading} />

      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="container" style={{ backgroundColor: "white" }}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active tbbtn"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                onClick={resetSearch}
              >
                Agent Limits ({limitList.length})
              </button>
            </div>
          </nav>

          <div className="filterBtn">
            <SearchTable
              searchTerm={searchTerm}
              handleSearchChange={handleSearchChange}
            />

            <div className="dt-buttons ui-buttonset">
              <a
                className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg"
                tabIndex={0}
                aria-controls="examplemgm"
              >
                <span className="ui-button-text" onClick={addNewAgentLimits}>
                  Add Agent Limits
                </span>
              </a>
            </div>
          </div>

          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px" }}
          >
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
              style={{ position: "relative" }}
            >
              <div className="multi">
                <a
                  className="nav-link dropdown-toggle news fell jhb"
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    opacity: selectedRows.length > 0 ? 1 : "",
                    pointerEvents: selectedRows.length > 0 ? "auto" : "none",
                  }}
                >
                  <i className="fa fa-ellipsis-h" aria-hidden="true" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end mbv"
                  id="nvb"
                  aria-labelledby="navbarDropdown"
                  style={{}}
                >
                  {/* <li>
                              <a className="dropdown-item modal__button" id="open-modal" href="javascript:void(0);" style={{fontSize: '13px'}}>Limits</a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#!" style={{fontSize: '13px'}}>Commission</a>
                            </li> */}
                  <li onClick={suspendMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Suspend
                    </a>
                  </li>
                  <li onClick={resumeMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Activate
                    </a>
                  </li>
                </ul>
                <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" />
              </div>
              <DataTable
                key={dataTableKey}
                columns={columns}
                data={filteredData}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                conditionalRowStyles={conditionalRowStyles}
                paginationPerPage={rowsPerPage}
                onSelectedRowsChange={selectRows}
                customStyles={customDataTableStyles}
              />
            </div>
          </div>
        </div>
      </div>
      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={() => updateStatus(false)}
        status={row.status}
        modalId={row.modalId}
      ></Confirmation>
    </div>
  );
};
// function mapStateToProps(state) {
//   const userData = state.authReducer.user;
//   return { userData };
// }
// export default connect(mapStateToProps)(AgentCommissionListView);
export default AgentLimitListView;
